import { render, staticRenderFns } from "./CheckFirmBxTraid.vue?vue&type=template&id=efea4b1c&"
import script from "./CheckFirmBxTraid.vue?vue&type=script&lang=js&"
export * from "./CheckFirmBxTraid.vue?vue&type=script&lang=js&"
import style0 from "./CheckFirmBxTraid.vue?vue&type=style&index=0&id=efea4b1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports